import React, { useRef }from 'react';
import styled from 'styled-components';
import '@process-advisor/process-miner/shared/gridStyles.css'

const Wrapper = styled.div`
    margin-top: 10px;
    margin-bottom: 5px;
`;

export const DataGrid  = ({
    rows,
    columns,
    height
}) => {

    React.useEffect(() => {
        console.log(rows)
        console.log(columns)
    }, []);

   
    return (
        <Wrapper height={height}>
 <div style={{ fontFamily: '"Atlassian Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif' }}>
      <div style={{ 
        border: '1px solid #ddd',
        borderRadius: '4px',
        overflow: 'hidden',
        maxWidth: '500px'
      }}>
        <table style={{ 
          width: 'auto',
          borderCollapse: 'collapse',
          backgroundColor: 'white',
          fontSize: '13px'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#f5f5f5' }}>
              {columns.map((col, idx) => (
                <th 
                  key={idx}
                  style={{
                    padding: '6px 12px',
                    textAlign: 'left',
                    fontWeight: '600',
                    borderBottom: '2px solid #ddd',
                    maxWidth: '400px',
                    wordWrap: 'break-word'
                  }}
                >
                  {col.headerName}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIdx) => (
              <tr 
                key={rowIdx}
                style={{
                  borderBottom: '1px solid #eee',
                  transition: 'background-color 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9f9f9'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
              >
                {columns.map((col, colIdx) => (
                  <td 
                    key={colIdx}
                    style={{
                      padding: '6px 12px',
                      borderBottom: '1px solid #eee',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {row[col.field]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>        </Wrapper>
    );
};

